<!--
 * @Description:
 * @Date: 2021-07-19 16:35:52
-->
<template>
  <div class="box">
    <el-form label-width="120px" :model="formParams" ref="form">
      <el-form-item
        :label="item.label"
        v-for="item in form"
        :key="item.key"
        :prop="item.key"
        :rules="item.rules || []"
        :style="{ width: item.width }"
      >
        <template v-if="item.slot === 'dicSelect'">
          <dic-select
            style="width:100%;"
            v-on="item.listener"
            @dic-select-obj="
              val => {
                item.callback && item.callback(val);
                formParams[item.key] = val[item.attrs.useValueKey];
                item.key1 &&
                  item.attrs.useValueKey1 &&
                  (formParams[item.key1] = val[item.attrs.useValueKey1]);
              }
            "
            :fuzzyDef="item.selectAjax"
            v-bind="item.attrs"
            :placeholder="item.placeholder"
            class="data-item"
          ></dic-select>
        </template>
        <template v-if="item.slot === 'input'">
          <el-input
            v-bind="item.attrs"
            :placeholder="item.placeholder"
            v-model="formParams[item.key]"
            class="data-item"
          />
        </template>
        <template v-if="item.slot === 'date'">
          <el-date-picker
            style="width:100%;"
            :placeholder="item.placeholder"
            :value-format="item.valueFormat"
            v-model="formParams[item.key]"
            class="data-item"
            :type="item.type || 'month'"
            v-bind="item.attrs"
            v-on="item.listener"
          ></el-date-picker>
        </template>
        <template v-if="item.slot === 'custom'">
          <component
            :is="item.component"
            :value="formParams[item.key]"
            v-bind="item.attrs"
            v-on="item.listener"
          ></component>
        </template>
      </el-form-item>
    </el-form>
    <div style="text-align: center;padding-bottom:15px;">
      <el-button
        type="primary"
        @click="save"
        v-if="hasSave"
        :disabled="isSaving"
      >
        保存
      </el-button>
      <el-button @click="$xrkDialog.remove()">关闭</el-button>
    </div>
  </div>
</template>

<script>
import dicSelect from '@/components/Common/dicSelect.vue';
import OpenNewWin from '@/tools/openNewWin';
import uploadFile from './components/uploadFile';
import dateFormat from '@/tools/dateFormat';

export default {
  name: 'add-dutypaid-proof',
  components: { dicSelect },
  props: {
    id: Number,
    addType: Number, // 1新增 2查看 3编辑 4补充（仅附件可添加） 5上传（仅附件可编辑）
    useType: Number, // 1自然人-我发起 2自然人-我收到 3园区个体 4委托代开
    // 获取详情接口
    getAjax: {
      default() {
        return () => {};
      }
    },
    // 保存接口
    saveAjax: {
      default() {
        return () => {};
      }
    },
    // 客户接口
    customerAjax: {
      default() {
        return () => {};
      }
    }
  },
  data() {
    return {
      isSaving: false,
      formParams: {
        customerName: '', // 客户名称（保存）
        customerId: '', // 客户ID
        showEnterpriseName: '', // 客户显示名
        enterpriseIdentifierNo: '', // 客户识别号
        _proofMonth: [], // 自定义所得月份
        proofMonthStart: '',
        proofMonthEnd: '', // 所得月份止
        taxPaymentStart: '',
        taxPaymentEnd: '', // 税筹所属期止
        peopleCount: '', // 人数
        attachmentList: [] // 附件
      },
      enterpriseIdentifierNoDisabled: false // 如果选择的企业有号则不可编辑识别号
    };
  },
  computed: {
    // 都不可操作
    disabled() {
      return this.addType === 2;
    },
    // 只可操作上传
    onlyUpload() {
      return [4, 5].includes(this.addType);
    },
    // 都可编辑
    fullEditing() {
      return [1, 3].includes(this.addType);
    },
    hasSave() {
      return this.onlyUpload || this.fullEditing;
    },
    // 是否为补充上传
    uploadType() {
      return this.addType === 4 ? 1 : 0; // uploadType:上传类型 1-补充上传 0-非补充上传
    },
    // 园区个体
    isIndividual() {
      return this.useType === 3;
    },
    form() {
      const { formParams } = this;
      const checkNumber = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('不能为空'));
        } else if (!/^[+]{0,1}(\d+)$/g.test(`${value}`)) {
          callback(new Error('请填写整数'));
        } else {
          callback();
        }
      };
      const inputRequired = [
        { required: true, message: '请输入内容', trigger: 'blur' }
      ];
      const selectRequired = [
        { required: true, message: '请选择内容', trigger: 'change' }
      ];

      const uploadCmp = () => {
        return !this.disabled
          ? {
              width: '100%',
              label: '完税证明附件',
              slot: 'custom',
              key: 'attachmentList',
              component: {
                render: () => {
                  return (
                    <div style="display: flex;flex-wrap: wrap;">
                      <uploadFile
                        fileList={formParams.attachmentList.map(i => ({
                          name: i.attachementName || i.name,
                          url: i.attachmentUrl || i.url
                        }))}
                        onSuccess={fileList => {
                          formParams.attachmentList = fileList;
                          try {
                            this.$refs['form'].validateField('attachmentList');
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      ></uploadFile>
                    </div>
                  );
                }
              },
              rules: selectRequired
            }
          : {
              label: '完税证明附件',
              slot: 'custom',
              width: '100%',
              key: 'attachmentList',
              rules: inputRequired,
              component: {
                props: { value: Array },
                render() {
                  const { value = [] } = this;
                  return (
                    <div>
                      {value.map(item => {
                        return (
                          <el-button
                            type="text"
                            onClick={() => {
                              const newWin = new OpenNewWin();
                              newWin.createWin();
                              newWin.setUrl(item.attachmentUrl);
                            }}
                          >
                            <span style="display: inline-block;white-space: break-spaces;text-align: left;">
                              {item.attachementName}
                            </span>
                          </el-button>
                        );
                      })}
                    </div>
                  );
                }
              }
            };
      };
      if (this.fullEditing) {
        return [
          {
            label: '客户企业',
            slot: 'dicSelect',
            key: 'showEnterpriseName',
            key1: 'customerId',
            selectAjax: this.customerAjax,
            callback: info => {
              formParams.customerId = info.id;
              formParams.enterpriseIdentifierNo = info.enterpriseIdentifierNo;

              formParams.customerName = info.enterpriseName; // 搜索接口返回字段key与使用字段不一致
              // 保存字段与显示字段不一致
              formParams.showEnterpriseName = formParams.enterpriseName =
                info.showEnterpriseName || info.enterpriseName;
              this.$refs['form'].validateField([
                'customerName',
                'enterpriseIdentifierNo'
              ]);
              // 选择的企业有号则不可修改识别号
              this.enterpriseIdentifierNoDisabled = !!info.enterpriseIdentifierNo;
            },
            attrs: {
              useValueKey: 'showEnterpriseName',
              useValueKey1: 'id',
              allowCreate: !this.isIndividual, // 个体园区不可新增
              prop: {
                label: 'showEnterpriseName',
                code: 'id'
              },
              ajaxQuery: 'keyWord',
              ajaxQueryObj: {},
              defaultActive: {
                customerName: formParams.customerName,
                showEnterpriseName: formParams.showEnterpriseName,
                id: formParams.customerId
              }
            },
            placeholder: '请选择客户企业',
            rules: selectRequired
          },
          !this.isIndividual && {
            label: '纳税人识别号',
            placeholder: '请输入纳税人识别号',
            slot: 'input',
            key: 'enterpriseIdentifierNo',
            rules: [
              {
                validator: (rule, value, callback) => {
                  if (value === '') {
                    callback(new Error('不能为空'));
                  } else if (!/^[A-Za-z0-9]+$/g.test(`${value}`)) {
                    callback(new Error('请填写正确格式的识别号'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change'
              },
              ...inputRequired
            ],
            attrs: {
              disabled: this.enterpriseIdentifierNoDisabled
            }
          },
          {
            label: '所得月份',
            placeholder: '请选择所得月份',
            slot: 'date',
            type: 'monthrange',
            valueFormat: 'yyyy-MM',
            rules: selectRequired,
            key: '_proofMonth', // 自定义key
            attrs: {
              // 'picker-options': {
              //   disabledDate(time) {
              //     return time > nowDate;
              //   }
              // },
              'start-placeholder': '所的月份起',
              'end-placeholder': '所的月份止'
            },
            listener: {
              change: e => {
                if (e) {
                  const [start, end] = e;
                  const date = new Date(end);
                  const lastDay = new Date(
                    date.getFullYear(),
                    +date.getMonth() + 1,
                    0
                  ).getDate();
                  this.$set(this.formParams, 'taxPaymentStart', `${start}-01`);
                  this.$set(
                    this.formParams,
                    'taxPaymentEnd',
                    `${end}-${lastDay}`
                  );
                  this.formParams['proofMonthStart'] = start;
                  this.formParams['proofMonthEnd'] = end;
                } else {
                  this.formParams['proofMonthStart'] = '';
                  this.formParams['proofMonthEnd'] = '';
                }
              }
            }
          },
          !this.isIndividual && {
            label: '完税人数',
            placeholder: '请输入完税人数',
            slot: 'input',
            key: 'peopleCount',
            rules: [
              {
                validator: checkNumber,
                trigger: 'blur'
              },
              ...inputRequired
            ]
          },
          {
            label: '税款所属期起',
            placeholder: '请选择税款所属期起',
            slot: 'date',
            type: 'date',
            key: 'taxPaymentStart',
            valueFormat: 'yyyy-MM-dd',
            rules: selectRequired,
            attrs: {
              // 完税证明优化需求去掉了限制
              // 'picker-options': {
              //   disabledDate(time) {
              //     return time > nowDate;
              //   }
              // }
            }
          },
          {
            label: '税款所属期止',
            placeholder: '请选择税款所属期止',
            slot: 'date',
            type: 'date',
            key: 'taxPaymentEnd',
            valueFormat: 'yyyy-MM-dd',
            attrs: {
              'picker-options': {
                disabledDate(time) {
                  if (!formParams.taxPaymentStart) {
                    return false;
                  }
                  return (
                    // 完税证明优化需求去掉了限制
                    // time > nowDate ||
                    dateFormat(time.getTime(), 'YYYY-MM-DD') <
                    formParams.startDt
                  );
                }
              }
            },
            rules: selectRequired
          },
          uploadCmp()
        ];
      }
      return [
        {
          label: '客户企业',
          slot: 'input',
          key: 'showEnterpriseName',
          attrs: {
            disabled: true
          },
          rules: inputRequired
        },
        !this.isIndividual && {
          label: '纳税人识别号',
          slot: 'input',
          key: 'enterpriseIdentifierNo',
          attrs: {
            disabled: true
          },
          rules: [
            {
              // 虚拟账号该字段可能为空，UI显示*但不校验
              required: true,
              validator: (rule, value, callback) => {
                callback();
              },
              trigger: 'blur'
            }
          ]
        },
        {
          label: '所得月份',
          slot: 'input',
          key: '_proofMonthText',
          attrs: {
            disabled: true
          },
          rules: inputRequired
        },
        !this.isIndividual && {
          label: '完税人数',
          slot: 'input',
          key: 'peopleCount',
          attrs: {
            disabled: true
          },
          rules: inputRequired
        },
        {
          label: '税款所属期起',
          slot: 'input',
          key: 'taxPaymentStart',
          attrs: {
            disabled: true
          },
          rules: inputRequired
        },
        {
          label: '税款所属期止',
          slot: 'input',
          key: 'taxPaymentEnd',
          attrs: {
            disabled: true
          },
          rules: inputRequired
        },
        uploadCmp()
      ];
    }
  },
  methods: {
    save() {
      if (this.isSaving) {
        return;
      }
      try {
        if (
          this.formParams.attachmentList.filter(i => i.attachmentUrl || i.url)
            .length == 0
        ) {
          this.$message.error('请上传完税证明附件');
          return;
        }
      } catch (error) {
        console.warn(error);
      }
      this.$refs['form'].validate(v => {
        if (v) {
          this.isSaving = true;
          const individualData = {
            userEnterpriseParkId: this.$store.state.homeProject
              .userEnterpriseParkId,
            userId: this.$store.state.user.user.id,
            userEnterpriseId: this.formParams.customerId
          };
          this.saveAjax({
            id: this.id,
            ...this.formParams,
            uploadType: this.uploadType,
            customerName:
              this.formParams.customerName ||
              this.formParams.showEnterpriseName, // 当用户自己手填写时候，全都给后端
            attachmentList: this.formParams.attachmentList.map(i => ({
              attachementName: i.attachementName || i.name,
              attachmentUrl: i.attachmentUrl || i.url,
              dutyPaidProofId: this.id
            })),
            ...(this.isIndividual && individualData)
          })
            .then(() => {
              this.$emit('confirm');
              this.$message.success('保存成功');
              this.$xrkDialog.remove();
            })
            .catch(() => {
              this.isSaving = false;
            });
        }
      });
    }
  },
  async created() {
    if (this.id) {
      const {
        data: { data }
      } = await this.getAjax();
      this.formParams = {
        ...data,
        customerName: data.customerName || data.csoName,
        showEnterpriseName:
          data.showEnterpriseName || data.showCustomerName || data.customerName, // showEnterpriseName新增字段可能没有数据，兼容数据出错
        _proofMonth: [data.proofMonthStart || '', data.proofMonthEnd || ''],
        _proofMonthText:
          data.proofMonthStart + ' - ' + (data.proofMonthEnd || data.proofMonth)
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  .el-form {
    display: flex;
    flex-wrap: wrap;

    &-item {
      width: 50%;
      margin-bottom: 45px;
    }
  }

  .data-item {
    width: 340px;
  }
}
</style>
